var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1111 0C40.4077 0 41.6512 0.515078 42.5681 1.43192C43.4849 2.34877 44 3.59227 44 4.88889V39.1111C44 40.4077 43.4849 41.6512 42.5681 42.5681C41.6512 43.4849 40.4077 44 39.1111 44H4.88889C3.59227 44 2.34877 43.4849 1.43192 42.5681C0.515078 41.6512 0 40.4077 0 39.1111V4.88889C0 3.59227 0.515078 2.34877 1.43192 1.43192C2.34877 0.515078 3.59227 0 4.88889 0H39.1111ZM37.8889 37.8889V24.9333C37.8889 22.8199 37.0493 20.7929 35.5549 19.2985C34.0604 17.804 32.0335 16.9644 29.92 16.9644C27.8422 16.9644 25.4222 18.2356 24.2489 20.1422V17.4289H17.4289V37.8889H24.2489V25.8378C24.2489 23.9556 25.7644 22.4156 27.6467 22.4156C28.5543 22.4156 29.4248 22.7761 30.0665 23.4179C30.7083 24.0597 31.0689 24.9301 31.0689 25.8378V37.8889H37.8889ZM9.48444 13.5911C10.5736 13.5911 11.6181 13.1584 12.3883 12.3883C13.1584 11.6181 13.5911 10.5736 13.5911 9.48444C13.5911 7.21111 11.7578 5.35333 9.48444 5.35333C8.38881 5.35333 7.33804 5.78857 6.56331 6.56331C5.78857 7.33804 5.35333 8.38881 5.35333 9.48444C5.35333 11.7578 7.21111 13.5911 9.48444 13.5911ZM12.8822 37.8889V17.4289H6.11111V37.8889H12.8822Z",
    fill: "#9C9D9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.651c76f9e6281fd832e9008006473063.svg";
export { ForwardRef as ReactComponent };